/**
 * `/accounts/:accountId/assistants/:AssistantID/myassistant/evals` — the only
 * place Evals is mounted (`AppRouter.tsx`, the `myassistant` group). Anchored at
 * both ends, so anything nested below never matches; a substring test would
 * also catch an id that happens to contain the segment.
 */
const EVALS_ROUTE = /^\/accounts\/[^/]+\/assistants\/[^/]+\/myassistant\/evals\/?$/;

export function isEvalsPath(pathname: string): boolean {
  return EVALS_ROUTE.test(pathname);
}
